import {default as MUIBox} from '@mui/material/Box';

export default MUIBox